<template>
  <div>
    <el-carousel :height="imgWidth*0.333 + 'px'">
      <el-carousel-item v-for="(item,index) in imgs" :key="index">
        <img :src="item.image" alt style="width:100%;height:100%;" />
      </el-carousel-item>
    </el-carousel>
    <div class="lunbo_title">电测 计量 检定 校验</div>
    <div id="main">
      <!-- 第一层 -->
      <div class="goods_first">
        <div class="goods_item" v-for="item in goods_first" :key="item.id">
          <div>{{item.name}}</div>
          <el-image class="img" :src="item.image" alt fit="scale-down"></el-image>
        </div>
      </div>
      <!-- 第二层 -->
      <div class="goods_second">
        <div class="goods_item" v-for="item in goods_second" :key="item.id">
          <div>{{item.name}}</div>
          <el-image class="img" :src="item.image" alt fit="scale-down"></el-image>
        </div>
      </div>

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in bottom_imgs" :key="item.id">
            <div>
              <img class="img" :src="item.image" alt />
              <!-- <el-image class="img" :src="item.image" alt fit="scale-down"></el-image> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Swiper from "swiper";
// import "swiper/dist/css/swiper.css";
export default {
  data: function () {
    return {
      imgWidth: "",
      imgs: [],
      goods_first: [],
      goods_second: [],
      bottom_imgs: [], // 底部轮播图片
    };
  },
  created: function () {
    setTimeout(function () {
      $(".lunbo_title").css({ transform: "scale(1)", transition: "2s" });
    }, 1000);
    setTimeout(function () {
      $(".lunbo_title").css({ transform: "scale(0)", transition: "2s" });
    }, 3000);
    setInterval(() => {
      setTimeout(function () {
        $(".lunbo_title").css({ transform: "scale(1)", transition: "2s" });
      }, 1000);
      setTimeout(function () {
        $(".lunbo_title").css({ transform: "scale(0)", transition: "2s" });
      }, 3000);
    }, 5000);
    // 获取轮播图数据
    this.$fetch("index/getAdList", { slot_id: 1 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.imgs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
    this.imgWidth = document.body.clientWidth;
    // 获取底部部分轮播
    this.$fetch("index/getBottomPic", { cate_id: 1 }).then((res) => {
      if (res.code == 1) {
        this.bottom_imgs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });

    // 获取中间部分产品
    this.$fetch("index/index").then((res) => {
      // console.log(res);
      if (res.code == 1) {
        this.goods_first = res.data.first_category;
        this.goods_second = res.data.last_category;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
  },
  updated: function () {
    var mySwiper = new Swiper(".swiper-container", {
      autoplay: 3000,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
      loop: true,
      speed: 500,
    });
  },
};
</script>
<style scoped>
.lunbo_title {
  position: absolute;
  color: #fff;
  font-size: 54px;
  font-family: SimHei;
  font-weight: bold;
  top: 250px;
  left: 34%;
  z-index: 10;
  transform: scale(0);
}
.goods_first {
  width: 100%;
  margin: 40px 0px;
}
.goods_first .goods_item {
  height: 360px;
  display: inline-block;
  width: 570px;
  background-color: #e8e8e8;
  border-radius: 20px;
}
.goods_first .goods_item:first-child {
  margin-right: 40px;
}
.goods_first .goods_item div {
  font-size: 18px;
  padding-top: 20px;
  text-align: center;
}
.goods_first .goods_item .img {
  width: 372px;
  height: 230px;
  float: left;
  margin: 20px 97px 56px 100px;
}

.goods_second {
  width: 100%;
  margin-bottom: 40px;
}
.goods_second .goods_item {
  width: 365px;
  height: 360px;
  background-color: #e8e8e8;
  margin: 20px 45px 0 0;
  border-radius: 20px;
  display: inline-block;
}
.goods_second .goods_item:nth-child(3n) {
  margin-right: 0;
}
.goods_second .goods_item div {
  font-size: 18px;
  padding-top: 40px;
  text-align: center;
}
.goods_second .goods_item .img {
  width: 320px;
  height: 200px;
  margin: 20px;
}
.imgDiv img:nth-child(4n) {
  margin-right: 0;
}
.swiper-slide div {
  padding: 20px 20px;
}
.swiper-slide div .img {
  height: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue